const c = {
  name: "Macos",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,12v5h-2v-5H13z"/>
		<path class="st0" d="M29,17v-5h-2v5H29z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v30
			c0,1.7,1.3,3,3,3h18.6c-0.7-2.2-1.1-4.3-1.4-6.1C21.5,32,20.8,32,20,32c-5.2,0-10-2.1-13.4-5.6L8,25c3.1,3.1,7.3,5,12,5
			c0.7,0,1.4,0,2-0.1c-0.1-0.8-0.1-1.5-0.2-2.2c-0.1-1.5,0-2.7,0-3.5c0-0.1,0-0.1,0-0.2H16v-1c0-6.1,1.3-11.7,2.5-15.8
			c0.6-2,1.3-3.7,1.8-4.8c0.1-0.1,0.1-0.2,0.2-0.4H5z M24.2,31.5c0.3,1.9,0.7,4.1,1.5,6.5H35c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3
			H22.6c-0.1,0.3-0.3,0.7-0.5,1.1c-0.5,1.1-1.1,2.7-1.7,4.7c-1.2,3.7-2.3,8.7-2.4,14.2h6.1L24,23.1l0,0l0,0l0,0.1c0,0,0,0.1,0,0.2
			c0,0.2,0,0.5-0.1,0.9c0,0.8-0.1,1.9,0,3.3c0,0.6,0.1,1.2,0.1,1.9c3.1-0.7,5.8-2.3,8-4.5l1.4,1.4C30.9,28.9,27.8,30.7,24.2,31.5z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  c as Macos
};
